// In PackageTypes.tsx
import React, { useState } from "react";
import { PackageManagement } from "../components/commission/PackageManagement";

export const PackageTypes: React.FC = () => {
  const [showCreate, setShowCreate] = useState(false);

  return (
    <div className="min-h-screen bg-gray-900 text-white relative">
      {/* Main Content */}
      <div className={`container mx-auto px-4 py-6 relative`}>
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-white mb-2">Package Types</h1>
          <p className="text-gray-400">
            Manage betting packages with different commission rates and bet
            amounts per point
          </p>
        </div>
        <PackageManagement setShowCreate={setShowCreate} />
      </div>

      {/* Blur overlay - only shown when showCreate is true */}
      {showCreate && (
        <div className="fixed inset-0 bg-black/5 backdrop-blur-sm z-10" />
      )}
    </div>
  );
};
